import React, { useEffect, useMemo } from "react";
import {
  Typography, Button, Grid, CircularProgress
} from "@material-ui/core";
import { makeStyles, Theme, createStyles, } from '@material-ui/core/styles';
import NotFound from './NotFound'
import * as wijmo from "@grapecity/wijmo";
import { useGlobalState, useDispatch } from '../provider/Provider'
import { useParams, useHistory } from 'react-router-dom';
import { getAllContractList, getBasicInfo, getCisDepartmentList, getCisUserList, getContract, getDetailsInfo, putContract, typeBasicInfo, typeCisDepartmentList, typeCisUserList, typeContractList, typeDetailsInfo } from "../api/helpline/keiyaku";
import { getVisits, typeVisits } from "../api/helpline/qa";
import { adminUser } from "../User";
import { getCategory, getMember, getMemberList, typeCategory, typeMemberList } from "../api/helpline/master";
import { typeDetailsForm, typeForm } from "./ContractRegist";
import { valueValidation } from "../validation";
import ContractEditForm from "../component/portal/contractedit/ContractEditForm";
import ContractEditDetails from "../component/portal/contractedit/ContractEditDetails";
import { green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      marginTop: -12,
      marginLeft: -42,
    },
  }),
);

interface Prop {
  handleError: (err: any) => void,
  handleClickQAno: (num: string) => void,
  handleListHistory: () => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleClickHome: () => void,
}


const newservice = process.env.REACT_APP_KEIYAKU_NEW_SERVICE!
const appservice = process.env.REACT_APP_KEIYAKU_NEW_APP!

const ContractEdit: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const globalState = useGlobalState('user')
  const globalconlistState = useGlobalState('contractlist')
  const { userId, token, role } = globalState
  const history = useHistory()
  const { handleError, handleClickQAno, handleListHistory, handleNotificationOpen, handleClickHome } = props
  //@ts-ignore
  const { keiyakuno } = useParams()
  const decode_keiyakuno = useMemo(() => {
    try {
      if (keiyakuno) {
        return atob(keiyakuno)
      } else {
        return ''
      }
    } catch {
      return keiyakuno
    }
  }, keiyakuno
  )
  const todayDate: Date = useMemo(() => new Date(Date.now()), [])
  const [basicInfo, setBasicInfo] = React.useState<typeBasicInfo>()
  const [detailsInfo, setDetailsInfo] = React.useState<typeDetailsInfo[]>()
  const [visitsInfo, setVisitsInfo] = React.useState<typeVisits[]>()
  const [mailservice, setMailservice] = React.useState<boolean[] | null>([false, false])
  const [form, setForm] = React.useState<typeForm | null>()
  //契約詳細
  const [detailsform, setDetailsform] = React.useState<typeDetailsForm[] | null>()
  const [reqbasicItem, setReqbasicItem] = React.useState({
    custmNo: true,//顧客名
    custmDepNo: true,//顧客名
    keiyakuNo: true,//契約書番号
    orderNo: true,//受注番号
    keiyakuClsCd: true,//契約項目
    keiyakuStartTs: true,//契約開始日
    renewalMonth: true,//契約更新月
    keiyakuPersonCd: true,//契約担当者
    keiyakuDeposit: true,//契約金額
    totalPrice: true,//合計金額
    machineSettingZipCd: true,//機械設置場所 〒
    machineSettingAddress: true,//機械設置場所 住所
  })
  const [reqinvoiceItem, setReqinvoiceItem] = React.useState({
    demandZipCd: true,//請求先〒
    demandAddress: true,//請求先住所
    demandCompanyName: true,//請求先会社名
    demandPersonName: true,//請求先担当者名
    demandMonth: true,//請求月
    actionSeDeptCd: true,//担当(実施)SEcd
  })
  const [checkinvoiceItem, setCheckinvoiceItem] = React.useState({
    monthlyPrice: true, //請求金額
    monthlyPrice2: true, //請求金額2
    demandZipCd: true,//請求先〒
  })

  const [checkbasicItem, setCheckbasicItem] = React.useState({
    keiyakuNo: true,
    orderNo: true,
    keiyakuDeposit: true,
    totalPrice: true,
    incidentDeposit: true,
    visitCount: true,
    incidentCount: true,
    machineSettingZipCd: true,
    incidentAddCount: true,
    incidentUsedCount: true,
  })
  const monthList = useMemo(() => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], [])
  const monthSelect = useMemo(() => [{ value: 'all', name: '毎月' }, { value: 'select', name: '選択月' }], [])
  const renewalMonthSelect = useMemo(() => [{ value: 'renewal', name: '更新' }, { value: 'cancel', name: '解約' }], [])
  //支払い方法
  const [payment, setPayment] = React.useState<typeCategory[]>([])
  //CIS社員情報
  const [cisUserList, setCisUserList] = React.useState<typeCisUserList[]>([])
  //CIS組織情報
  const [cisDepartmentList, setCisDepartmentList] = React.useState<typeCisDepartmentList[]>([])
  //契約項目全取得
  const [contractList, setContractList] = React.useState<typeContractList[]>()
  //選択契約項目
  const [selectKeiyaku, setSelectKeiyaku] = React.useState<typeContractList>()
  //メンバー情報一覧
  const [memberList, setMemberList] = React.useState<typeMemberList[]>([])
  //選択メンバー情報
  const [selectmember, setSelectmember] = React.useState<typeMemberList>()
  const [demandSelect, setDemandSelect] = React.useState<string>('all')
  const [renewalSelect, setRenewalSelect] = React.useState<string>('renewal')
  const [kaiyakuTs, setKaiyakuTs] = React.useState<Date | null>(null)
  const [loading, setLoading] = React.useState<boolean>(false)

  const backPage = () => {
    dispatch({ type: 'SET_PAGE', payload: globalState, page: { backpage: true }, qalist: [], contractlist: globalconlistState })
    history.go(-1)//戻る
  }

  const mailCheckbox = useMemo((): boolean[] | null => {
    if (basicInfo || form) {
      let serviceId: string | any[] = []
      if (basicInfo?.mailClsCd) {
        serviceId = basicInfo.mailClsCd.split(',')
      } else if (form?.mailClsCd) {
        serviceId = form.mailClsCd.split(',')
      }
      if (serviceId.length > 1) {
        return [true, true]
      } else if (serviceId[0] === '3') {
        return [true, false]
      } else if (serviceId[0] === '5') {
        return [false, true]
      } else {
        return [false, false]
      }
    } else {
      return null
    }
  }, [basicInfo, form?.mailClsCd])

  const chipDelete = (i: number, name: string) => {
    if (form) {
      if (name === "renewalMonth") {
        setForm({
          ...form,
          renewalMonth: form.renewalMonth.filter(value => value !== i),
        })
      } else if (name === "demandMonth") {
        setForm({
          ...form,
          demandMonth: form.demandMonth.filter(value => value !== i),
        })
      }
    }
  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    if (form) {
      if (event.target.name === "renewalMonth" || event.target.name === "demandMonth") {
        setForm({
          ...form,
          [event.target.name as string]: event.target.value as []
        })
      } else {
        setForm({
          ...form,
          [event.target.name as string]: event.target.value as string
        })
      }
    }
  }

  const handleChangeKeiyakuCd = (keiyakuObj: typeContractList) => {
    if (form) {
      if (keiyakuObj) {
        setForm({ ...form, keiyakuClsCd: keiyakuObj.keiyakuClsCd })
        setSelectKeiyaku(keiyakuObj)
      } else {
        setForm({ ...form, keiyakuClsCd: '' })
        setSelectKeiyaku(undefined)
      }
    }
  }

  const handleChangeUserCd = (memberObj: typeMemberList) => {
    if (form) {
      setForm({ ...form, keiyakuPersonCd: memberObj.userCd, })
    }
  };

  useEffect(() => {
    if (basicInfo || form) {
      setMailservice(mailCheckbox)
    }
  }, [basicInfo, form])

  //初期APIコール
  useEffect(() => {
    let cleanup = false
    handleListHistory()//pagehomeをfalseに設定QA編集画面遷移後にhistory.push(-1)を実行
    if (userId && token && role && decode_keiyakuno) {
      //訪問情報
      getVisits(userId, token, role, decode_keiyakuno).then(res => { if (!cleanup) { setVisitsInfo(res) } }).catch(err => handleError(err))
      if (!adminUser(role)) {
        //基本情報
        getBasicInfo(userId, token, role, decode_keiyakuno).then(res => { if (!cleanup) { setBasicInfo(res) } }).catch(err => handleError(err))
        //詳細情報
        getDetailsInfo(userId, token, role, decode_keiyakuno).then(res => { if (!cleanup) { setDetailsInfo(res) } }).catch(err => handleError(err))
      } else {//編集用
        //契約情報取得
        getContract(userId, token, role, decode_keiyakuno).then(res => {
          if (!cleanup) {
            if (res === null) {
              setForm(res)
            } else {
              const resBt = { ...res.keiyakuBt, updateCd: userId, updateDate: todayDate }
              setForm(resBt)
              const resDt = res.keiyakuDt.map((value: typeDetailsForm) => {
                return { ...value, updateCd: userId, updateDate: todayDate }
              })

              setDetailsform(resDt)
              if (resBt.kaiyakuTs) { setKaiyakuTs(resBt.kaiyakuTs) }
            }
          }
        }).catch(err => handleError(err))
        //契約項目全取得
        getAllContractList(userId, token, role).then(res => { if (!cleanup) { setContractList(res) } }).catch(err => handleError(err))
        //問合わせ方法
        getCategory('payment', userId, token, role).then(res => { if (!cleanup) { setPayment(res) } }).catch(err => handleError(err))
        //CIS社員情報
        getCisUserList(userId, token, role, '').then(res => { if (!cleanup) { setCisUserList(res) } }).catch(err => handleError(err))
        //CIS組織情報
        getCisDepartmentList(userId, token, role).then(res => { if (!cleanup) { setCisDepartmentList(res) } }).catch(err => handleError(err))
      }
    }
    return () => { cleanup = true }
  }, [userId, token, role, decode_keiyakuno])

  const _onInitialized = (sender: any) => {
    sender.calendar.formatItem.addHandler((sender: any, e: any) => {
      let weekday = e.data.getDay();
      wijmo.toggleClass(e.item, "date-sunday", weekday === 0);
      wijmo.toggleClass(e.item, "date-saturday", weekday === 6);
    })
  }

  const _onValueChanged = (sender: { value: Date | null }) => {
    if (sender.value) {
      setKaiyakuTs(sender.value)
    } else {
      setKaiyakuTs(null)
    }

  }

  //Wijmo 日付をformに挿入
  useEffect(() => {
    if (form) {
      setForm({ ...form, kaiyakuTs: kaiyakuTs })
    }
  }, [kaiyakuTs, renewalSelect])

  useEffect(() => {
    if (form && form.keiyakuClsCd && contractList && contractList.length !== 0) {
      setSelectKeiyaku(contractList.filter(value => value.keiyakuClsCd === form.keiyakuClsCd)[0])
    }
  }, [form, contractList])

  const handleChangeSalesPersonCd = (salesPersonCdObj: typeCisUserList | null) => {
    if (form) {
      if (salesPersonCdObj && salesPersonCdObj.userCd && salesPersonCdObj.departmentCd) {
        setForm({
          ...form,
          salesPersonCd: salesPersonCdObj.userCd,
          salesDeptCd: salesPersonCdObj.departmentCd
        })
      } else {
        setForm({ ...form, salesPersonCd: '', salesDeptCd: '' })
      }
    }
  };

  const handleChangeChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (form) {
      let mailclslist = form.mailClsCd.length ? form.mailClsCd.split(',') : []
      if (event.target.checked) {
        if (!mailclslist.includes(event.target.value)) {//配列に値がない場合に追加
          mailclslist.push(event.target.value)
        }
      } else {
        if (mailclslist.includes(event.target.value)) {//配列に値がある場合に削除
          mailclslist = mailclslist.filter(value => value !== event.target.value)
        }
      }
      setForm({ ...form, mailClsCd: mailclslist.join() });
    }
  }

  const handleChangeDepartmentCd = (departmentObj: typeCisDepartmentList) => {
    if (form) {
      setForm({
        ...form,
        actionSeDeptCd: departmentObj.departmentCd
      })
    }
  };

  //ラジオボタンの値に応じて請求月を挿入
  const handleChangeDemandMonth = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (form) {
      if ((event.target as HTMLInputElement).value === 'all') {
        setForm({ ...form, demandMonth: monthList })
      } else {
        setForm({
          ...form, demandMonth: []
        })
      }
    }
  }

  //請求月の値に応じてラジオボタンを制御
  useEffect(() => {
    if (form) {
      if (JSON.stringify(form.demandMonth.concat().sort()) === JSON.stringify(monthList.concat().sort())) {
        setDemandSelect('all')
      } else {
        setDemandSelect('select')
      }
    }
  }, [form?.demandMonth])

  //ラジオボタンの値に応じて更新月
  const handleChangeRenewalMonth = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (form) {
      if ((event.target as HTMLInputElement).value === 'renewal') {
        setForm({ ...form, renewalMonth: [] })
        setKaiyakuTs(null)
      } else {
        setForm({ ...form, renewalMonth: [13], })
        setKaiyakuTs(todayDate)
      }
    }
  }

  //更新月の値に応じてラジオボタンを制御
  useEffect(() => {
    if (form) {
      if (form.renewalMonth[0] === 13) {
        setRenewalSelect('cancel')
      } else {
        setRenewalSelect('renewal')
      }
    }
  }, [form?.renewalMonth])

  const displayIncident = useMemo(() => {
    if (selectKeiyaku) {
      if (selectKeiyaku.keiyakuClsNotes === newservice || selectKeiyaku.keiyakuClsNotes === appservice) {
        return true
      } else {
        return false
      }
    } else { return false }
  }, [selectKeiyaku])

  const incidentUsedCountReset = () => {
    if (form) {
      setForm({
        ...form,
        incidentUsedCount: '0'
      })
    }
  }

  //顧客選択後APIコール
  useEffect(() => {
    let cleanup = false
    if (form && form.custmDepNo) {
      setMemberList([])//契約担当者再表示
      getMemberList(form.custmDepNo, userId, token, role).then(res => {//顧客メンバー取得
        if (!cleanup) { setMemberList(res); }
      })
    }
    return () => { cleanup = true }
  }, [form?.custmDepNo])


  useEffect(() => {
    let cleanup = false
    if (selectKeiyaku && form) {
      if (displayIncident) {
        if (!cleanup) {
          setForm({
            ...form,
            totalPrice: String(Number(form.keiyakuDeposit) + Number(form.incidentDeposit ? form.incidentDeposit : 0)),
            visitCount: ''
          })
        }
      } else {
        if (!cleanup) {
          setForm({
            ...form,
            totalPrice: form.keiyakuDeposit,
            incidentDeposit: '',
            incidentCount: '',
            incidentAddCount: '',
            incidentUsedCount: ''
          })
        }
      }
    }
    return () => { cleanup = true }
  }, [form?.keiyakuDeposit, form?.incidentDeposit, selectKeiyaku, displayIncident])


  useEffect(() => {
    let cleanup = false
    if (form && form.keiyakuPersonCd) {
      getMember(userId, token, role, form.keiyakuPersonCd).then(res => {
        if (res && !cleanup) { setSelectmember(res) }
      }).catch(err => handleError(err))
    }
    return () => { cleanup = true }
  }, [form?.keiyakuPersonCd])

  //必須項目&値チェック
  useEffect(() => {
    let cleanup = false
    if (!cleanup) {
      if (form) {
        setReqbasicItem({
          ...reqbasicItem,
          custmNo: form.custmNo ? false : true,
          custmDepNo: form.custmDepNo ? false : true,
          keiyakuNo: form.keiyakuNo ? false : true,
          orderNo: form.orderNo ? false : true,
          keiyakuClsCd: form.keiyakuClsCd ? false : true,
          keiyakuStartTs: form.keiyakuStartTs ? false : true,
          renewalMonth: form.renewalMonth.length ? false : true,
          keiyakuPersonCd: form.keiyakuPersonCd ? false : true,
          keiyakuDeposit: form.keiyakuDeposit ? false : true,
          totalPrice: form.totalPrice ? false : true,
          machineSettingZipCd: form.machineSettingZipCd ? false : true,
          machineSettingAddress: form.machineSettingAddress ? false : true,
        })
        setCheckbasicItem({
          ...checkbasicItem,
          keiyakuNo: valueValidation(form.keiyakuNo, 'keiyakuNo'),
          orderNo: valueValidation(form.orderNo, 'orderNo'),
          keiyakuDeposit: valueValidation(form.keiyakuDeposit, 'keiyakuDeposit'),
          totalPrice: valueValidation(form.totalPrice, 'totalPrice'),
          incidentDeposit: valueValidation(form.incidentDeposit, 'incidentDeposit'),
          visitCount: valueValidation(form.visitCount, 'visitCount'),
          incidentCount: valueValidation(form.incidentCount, 'incidentCount'),
          machineSettingZipCd: valueValidation(form.machineSettingZipCd, 'machineSettingZipCd'),
          incidentAddCount: valueValidation(form.incidentAddCount, 'incidentAddCount'),
          incidentUsedCount: valueValidation(form.incidentUsedCount, 'incidentUsedCount'),
        })
        setReqinvoiceItem({
          ...reqinvoiceItem,
          demandZipCd: form.demandZipCd ? false : true,
          demandAddress: form.demandAddress ? false : true,
          demandCompanyName: form.demandCompanyName ? false : true,
          demandPersonName: form.demandPersonName ? false : true,
          demandMonth: form.demandMonth.length ? false : true,
          actionSeDeptCd: form.actionSeDeptCd ? false : true,
        })
        setCheckinvoiceItem({
          ...checkinvoiceItem,
          monthlyPrice: valueValidation(form.monthlyPrice, 'monthlyPrice'),
          monthlyPrice2: valueValidation(form.monthlyPrice2, 'monthlyPrice2'),
          demandZipCd: valueValidation(form.demandZipCd, 'demandZipCd')
        })
      }
    }
    return () => { cleanup = true }
  }, [form])

  const errorBasicCheck = useMemo(() => {
    const reqbasicList = Object.entries(reqbasicItem).map(([key, value]) => (value))
    const checkbasicList = Object.entries(checkbasicItem).map(([key, value]) => {
      if (key === 'keiyakuNo') {
        return false
      } else {
        return value
      }
    })
    const concatbasicList = reqbasicList.concat(checkbasicList)
    return concatbasicList.includes(true)
  }, [checkbasicItem, reqbasicItem])

  const errorAllCheck = useMemo(() => {
    const reqinvoiceList = Object.entries(reqinvoiceItem).map(([key, value]) => (value))
    const checkinvoiceList = Object.entries(checkinvoiceItem).map(([key, value]) => (value))
    const concatallList = reqinvoiceList.concat(checkinvoiceList).concat([errorBasicCheck])
    return concatallList.includes(true)
  }, [errorBasicCheck, checkinvoiceItem, reqinvoiceItem])

  const onSubmit = () => {
    setLoading(true)
    putContract(userId, token, role, form!, detailsform!).then(res => {
      setLoading(false)
      if (typeof (res) === 'boolean') {
        handleNotificationOpen('success', '契約の更新')
        handleClickHome()
      } else {
        handleError(res)
      }
    }).catch(err => { setLoading(false); handleError(err) })
  }

  return (
    <React.Fragment>
      <Grid container direction="row" justify="flex-start">
        <Typography variant="h6" style={adminUser(role) ? {} : { flexGrow: 1 }}>
          {adminUser(role) ? '契約情報編集' : '契約情報照会'}
        </Typography>
        {adminUser(role) &&
          <div style={{ flexGrow: 1 }}>
            <div className={classes.wrapper}>
              <Button color="primary" variant="contained" size='small' style={{ marginLeft: '12px' }} onClick={onSubmit} disabled={errorAllCheck ? true : loading}>更新</Button>
              {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              {errorAllCheck ? <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>エラー項目があります</Typography> : checkbasicItem.keiyakuNo && <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>契約書番号が不正です</Typography>}

            </div>
          </div>}
        <Button variant="outlined" color="primary" onClick={(event) => backPage()}>
          戻る
        </Button>
      </Grid>
      <Grid container spacing={2} justify="center" >
        {(adminUser(role) ? form === null : basicInfo === null) ?
          <NotFound /> :
          <Grid item xs={12}>
            {adminUser(role) ?
              <ContractEditForm reqbasicItem={reqbasicItem} handleChangeForm={handleChangeForm} form={form} _onInitialized={_onInitialized} contractList={contractList} handleChangeKeiyakuCd={handleChangeKeiyakuCd} monthList={monthList} chipDelete={chipDelete} memberList={memberList} handleChangeUserCd={handleChangeUserCd} payment={payment} cisUserList={cisUserList} handleChangeSalesPersonCd={handleChangeSalesPersonCd} handleChangeChecked={handleChangeChecked} selectmember={selectmember} checkbasicItem={checkbasicItem} selectKeiyaku={selectKeiyaku} detailsform={detailsform} displayIncident={displayIncident} checkinvoiceItem={checkinvoiceItem} reqinvoiceItem={reqinvoiceItem} monthSelect={monthSelect} handleChangeDemandMonth={handleChangeDemandMonth} demandSelect={demandSelect} cisDepartmentList={cisDepartmentList} handleChangeDepartmentCd={handleChangeDepartmentCd} mailservice={mailservice} renewalMonthSelect={renewalMonthSelect} handleChangeRenewalMonth={handleChangeRenewalMonth} renewalSelect={renewalSelect} _onValueChanged={_onValueChanged} kaiyakuTs={kaiyakuTs} incidentUsedCountReset={incidentUsedCountReset} visitsInfo={visitsInfo} handleClickQAno={handleClickQAno} />
              : <ContractEditDetails basicInfo={basicInfo} mailservice={mailservice} detailsInfo={detailsInfo} visitsInfo={visitsInfo} handleClickQAno={handleClickQAno} />}
          </Grid>
        }
      </Grid>
    </React.Fragment>
  )
}

export default ContractEdit
